<template>
  <header>
    <!-- PC端 -->
    <div class="main" id="isPCF" :class="{ hideHeader: !showHeader }">
      <div>
        <div class="logo">
          <img
            src="https://growlib-glp-public.oss-cn-beijing.aliyuncs.com/images/www/common/logo.png"
            alt=" "
            @click="go('index')"
          />
        </div>
        <div class="right">
          <div
            class="list"
            v-for="item of list"
            :key="item.name"
            @mouseover="mouseOver(item.active)"
            @mouseleave="mouseLeave(item.active)"
            :class="{
              active:
                getActive(item) || (mouseName == item.active && showPullDown),
            }"
            @click="go(item.router)"
          >
            <div class="tab">
              {{ item.name }}
              <span
                class="line"
                v-if="getActive(item)"
                :class="{ active: getActive(item) }"
              ></span>
            </div>
            <img v-if="item.isHot" style="height: 14px; width: 10px; margin-top: -2px" src="./assets/icon_huo@2x.png" alt="">
            <div
              v-if="
                item.name === '解决方案' ||
                item.name === '关于我们' ||
                item.name === '新闻资讯' ||
                item.name === '产品与服务'
              "
            >
              <svg
                data-v-ba633cb8=""
                viewBox="0 0 1024 1024"
                style="width: 16px; height: 16px; margin-left: 10px"
                :style="getActive(item) ? 'color: #F27529' : ''"
                xmlns="http://www.w3.org/2000/svg"
                v-if="mouseName != item.active || !showPullDown"
              >
                <path
                  fill="currentColor"
                  d="M831.872 340.864 512 652.672 192.128 340.864a30.592 30.592 0 0 0-42.752 0 29.12 29.12 0 0 0 0 41.6L489.664 714.24a32 32 0 0 0 44.672 0l340.288-331.712a29.12 29.12 0 0 0 0-41.728 30.592 30.592 0 0 0-42.752 0z"
                ></path>
              </svg>
              <svg
                data-v-ba633cb8=""
                viewBox="0 0 1024 1024"
                style="
                  width: 16px;
                  height: 16px;
                  margin-left: 10px;
                  color: #f27529;
                "
                xmlns="http://www.w3.org/2000/svg"
                v-if="mouseName == item.active && showPullDown"
              >
                <path
                  fill="currentColor"
                  d="m488.832 344.32-339.84 356.672a32 32 0 0 0 0 44.16l.384.384a29.44 29.44 0 0 0 42.688 0l320-335.872 319.872 335.872a29.44 29.44 0 0 0 42.688 0l.384-.384a32 32 0 0 0 0-44.16L535.168 344.32a32 32 0 0 0-46.336 0z"
                ></path>
              </svg>
              <!-- <svg
              data-v-ba633cb8=""
              viewBox="0 0 1024 1024"
              style="width: 16px; height: 16px; margin-left: 4px;"
              xmlns="http://www.w3.org/2000/svg"
              @click="showDown(item.active)"
              v-if="!showIcon || (item.active !== downName && item.active === mouseName) || showPullDown ">
              <path fill="currentColor" d="M831.872 340.864 512 652.672 192.128 340.864a30.592 30.592 0 0 0-42.752 0 29.12 29.12 0 0 0 0 41.6L489.664 714.24a32 32 0 0 0 44.672 0l340.288-331.712a29.12 29.12 0 0 0 0-41.728 30.592 30.592 0 0 0-42.752 0z"></path>
            </svg>
            <svg
              data-v-ba633cb8=""
              viewBox="0 0 1024 1024"
              style="width: 16px; height: 16px; margin-left: 4px; color: #F27529;"
              xmlns="http://www.w3.org/2000/svg"
              @click="showUp(item.active)"
              v-if="(item.active === downName && showIcon) || (showPullDown && item.active === mouseName)">
              <path fill="currentColor" d="m488.832 344.32-339.84 356.672a32 32 0 0 0 0 44.16l.384.384a29.44 29.44 0 0 0 42.688 0l320-335.872 319.872 335.872a29.44 29.44 0 0 0 42.688 0l.384-.384a32 32 0 0 0 0-44.16L535.168 344.32a32 32 0 0 0-46.336 0z"></path>
            </svg> -->
            </div>
            <!-- <img
              src="https://growlib-glp-public.oss-cn-beijing.aliyuncs.com/images/www/common/hot.png"
              v-if="item.isHot && !getActive(item)"
              alt=""
            />
            <img
              src="https://growlib-glp-public.oss-cn-beijing.aliyuncs.com/images/www/common/hotSelect.png"
              v-if="item.isHot && getActive(item)"
              alt=""
            /> -->
          </div>
          <div class="list other overseas" @click="goOther('https://www.libseen.ai/')">
            <div class="other-box">
              <img src="data:image/png;base64,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"></img>
              <span class="kuang">海外站</span>
            </div>
          </div>
          <div class="list other" @click="goOther('/terrace')">
            <div class="other-box">
              <svg viewBox="0 0 1024 1024" xmlns="http://www.w3.org/2000/svg">
                <path d="M946.5 448.3L542 74.4c-16.7-15.3-43.2-15.3-59.9 0L77.6 448.3a31.9 31.9 0 0 0-10.4 23.6v410.6c0 17.6 14.3 31.9 31.9 31.9h283.4c17.6 0 31.9-14.3 31.9-31.9V674.3h195.2v208.2c0 17.6 14.3 31.9 31.9 31.9h283.4c17.6 0 31.9-14.3 31.9-31.9V471.9c0-9.2-3.8-17.7-10.4-23.6zM882.6 852.5H664.1V642.4c0-17.6-14.3-31.9-31.9-31.9H391.8c-17.6 0-31.9 14.3-31.9 31.9v210.1H141.4V483.2L512 141.6l370.6 341.6v369.3z M680 120h120v220l-120-110z" fill="currentColor"/>
              </svg>
              <span class="kuang">管理平台</span>
            </div>
          </div>
          <div class="telephone">
            <img
              src="http://growlib-glp-public.oss-cn-beijing.aliyuncs.com/res/1_6257fa991bf5e/568942101.png"
              alt=""
            />
            <img src="http://growlib-glp-public.oss-cn-beijing.aliyuncs.com/res/1_6257fa993c639/669905680.png" alt="" class="whiteImg">
            <span>400-888-1126</span>
          </div>
        </div>
        <!-- 产品服务的下拉 -->
        <div
          class="product productService"
          :class="{
            showproductService:
              mouseName == 'product' &&
              (showPullDown || (showIcon && downName == 'product')),
          }"
          @mouseover="mouseOver('product')"
          @mouseleave="mouseLeave('product')"
        >
          <div
            @click="go(item.router, item.type)"
            v-for="item of productList"
            :class="{ active: getActiveTab(item) }"
            :key="item.title"
          >
            {{ item.title }}
          </div>
        </div>
        <!-- 解决方案下拉 -->
        <div
          class="plan"
          @mouseover="mouseOver('example')"
          @mouseleave="mouseLeave('example')"
          :class="{ showPlan: mouseName == 'example' && showPullDown }"
          ref="plan"
        >
          <div>
            <div class="higher" v-for="category in solutionList" :key="category.catid">
              <div class="headline">{{ category.name }}</div>
              <div class="content">
                <div class="list" v-for="item of category.list" :class="{ active: getActiveTab(item) }"
                @click="go(item.router, item.id)" :key="item.id">{{ item.title }}</div>
              </div>
            </div>
          </div>
        </div>
        <!-- 新闻资讯 -->
        <div
          class="news"
          :class="{
            showproductNews:
              mouseName == 'news' &&
              (showPullDown || (showIcon && downName == 'news')),
          }"
          @mouseover="mouseOver('news')"
          @mouseleave="mouseLeave('news')"
        >
          <div
            @click="go(item.router, item.type)"
            v-for="item of newsList"
            :class="{ active: getActiveTab(item) }"
            :key="item.title"
          >
            {{ item.title }}
          </div>
        </div>
        <!-- 公司介绍下拉 -->
        <div
          class="about"
          :class="{
            showproductAbout:
              mouseName == 'about' &&
              (showPullDown || (showIcon && downName == 'about')),
          }"
          @mouseover="mouseOver('about')"
          @mouseleave="mouseLeave('about')"
        >
          <div
            @click="go(item.router, item.type)"
            v-for="item of aboutUsList"
            :class="{ active: getActiveTab(item) }"
            :key="item.title"
          >
            {{ item.title }}
          </div>
        </div>
      </div>
    </div>
    <!-- 手机端 -->
    <div class="mainPhone" id="isMobileF">
      <div class="top">
        <img
          src="https://growlib-glp-public.oss-cn-beijing.aliyuncs.com/images/www/common/more.png"
          alt=""
          @click="showMenuChange(true)"
          class="more"
        />
        <img
          src="https://growlib-glp-public.oss-cn-beijing.aliyuncs.com/images/www/common/logo.png"
          alt=""
          class="icon"
        />
      </div>
      <div class="showMore" :class="{ showMenu: showMenu }">
        <div class="content">
          <img
            src="https://growlib-glp-public.oss-cn-beijing.aliyuncs.com/images/www/common/close.png"
            class="close"
            alt=""
            @click="showMenuChange(false)"
          />
          <div class="list" v-for="item of list" :key="item.name">
            <div class="title" @click="phoneGo(item)">
              <span :class="{ active: getActive(item) }">{{ item.name }}</span>
              <img
                v-if="item.select != undefined"
                :class="{ imgSetect: item.select }"
                src="https://growlib-glp-public.oss-cn-beijing.aliyuncs.com/images/www/common/rightMore.png"
                alt=""
              />
              <!-- <img v-else-if='item.select' src="https://growlib-glp-public.oss-cn-beijing.aliyuncs.com/images/www/common/downMore.png" alt=""> -->
            </div>
            <!-- 产品服务 -->
            <div
              class="heightHide"
              :class="{ showProduct: item.active == 'product' && item.select }"
            >
              <div
                v-for="itemSun of productList"
                @click="go(itemSun.router, itemSun.type)"
                :key="itemSun.name"
              >
                <div class="tag">
                  <div class="circle"></div>
                  <span :class="{ active: getActiveTab(itemSun) }">{{
                    itemSun.title
                  }}</span>
                </div>
              </div>
            </div>
            <!-- 解决方案 -->
            <div
              class="heightHide"
              :class="{ showPlan: item.active == 'example' && item.select }"
            >
              <template v-for="category of solutionList">
                <div class="classify" :key="'cat-' + category.catid">
                  <div class="circle"></div>
                  <span>{{ category.name }}</span>
                </div>
                <div
                  v-for="itemSun of category.list"
                  :key="itemSun.id"
                  @click="go(itemSun.router, itemSun.id)"
                >
                  <div class="tag">
                    <div class="circle"></div>
                    <span :class="{ active: getActiveTab(itemSun) }">{{
                      itemSun.title
                    }}</span>
                  </div>
                </div>
              </template>
            </div>
            <!-- 新闻资讯 -->
            <div
              class="heightHide"
              :class="{ showNews: item.active == 'news' && item.select }"
            >
              <div
                v-for="itemSun of newsList"
                @click="go(itemSun.router, itemSun.type)"
                :key="itemSun.name"
              >
                <div class="tag">
                  <div class="circle"></div>
                  <span :class="{ active: getActiveTab(itemSun) }">{{
                    itemSun.title
                  }}</span>
                </div>
              </div>
            </div>
            <!-- 关于我们 -->
            <div
              class="heightHide"
              :class="{ showAbout: item.active == 'about' && item.select }"
            >
              <div
                v-for="itemSun of aboutUsList"
                @click="go(itemSun.router, itemSun.type)"
                :key="itemSun.name"
              >
                <div class="tag">
                  <div class="circle"></div>
                  <span :class="{ active: getActiveTab(itemSun) }">{{
                    itemSun.title
                  }}</span>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div
        class="showMoreCover"
        @click="showMenuChange(false)"
        :class="{ showMenuCover: showMenu }"
        v-show="showMenu"
      ></div>
    </div>
  </header>
</template>
<script>
import { planListHeader } from '@/services/api';
export default {
  computed: {
    showHeader() {
      return this.$store.getters.showHeader;
    }
  },
  data: function() {
    return {
      list: [
        {
          name: '首页',
          active: 'index',
          router: 'index'
        },
        {
          name: '产品与服务',
          active: 'product',
          router: '',
          select: false // 手机端是否展开
        },
        {
          name: '解决方案',
          active: 'example',
          router: '',
          select: false // 手机端是否展开
        },
        {
          name: '新闻资讯',
          active: 'news',
          router: '',
          select: false // 手机端是否展开
        },
        {
          name: '关于我们',
          active: 'about',
          router: '',
          select: false // 手机端是否展开
        }
      ],
      tabIndex: 'index',
      showPullDown: false,
      mouseName: '',
      planList: [],
      newsList: [
        {
          title: '公司资讯',
          active: 'news',
          router: 'news'
        },
        {
          title: '最新政策',
          router: 'policy',
          active: 'policy'
        }
      ],
      aboutUsList: [
        {
          title: '公司介绍',
          router: 'abstract',
          active: 'abstract'
        },
        {
          title: '发展历程',
          router: 'history',
          active: 'history'
        },
        {
          title: '荣誉资质',
          active: 'honors',
          router: 'honors'
        },
        {
          title: '加入我们',
          router: 'joinUs',
          active: 'joinUs'
        }
      ],
      productList: [
        {
          title: '产品中心',
          router: 'productCenter',
          active: 'product'
        },
        {
          title: '客户服务',
          router: 'service',
          active: 'service'
        }
      ],
      solutionList: [],
      showIcon: false,
      showMenu: false // 显示移动端菜单
    };
  },
  created: function() {},
  mounted() {
    this.tabIndex = this.$route.name;
    this.getPlan();
  },
  methods: {
    getPlan() {
      planListHeader().then(res => {
        res.data.list.forEach(category => {
          category.list.forEach(item => {
            item.router = 'plan';
            item.active = 'plan';
          });
        });
        this.solutionList = res.data.list.filter(cat => cat.catid !== '47');
      });
    },
    go(name, id, url) {
      let NowUrl = document.location.pathname;
      let canNewTag = ['/plan', '/productDetail']; // 自身可跳转白名单
      if ('/' + name === NowUrl && canNewTag.indexOf(NowUrl) === -1) {
        console.log('自身不跳转');
        return;
      }
      if (!name) {
        return;
      }
      this.showMenu = false;
      this.$router.push({
        name,
        query: {
          id
        }
      });
    },
    mouseOver(name) {
      this.mouseName = name;
      this.showPullDown = true;
    },
    mouseLeave(name) {
      this.showPullDown = false;
    },
    // 页面tab选中
    getActive(item) {
      // console.log('tab打印', this.tabIndex, '这是itemactive', item.active)
      return this.tabIndex.indexOf(item.active) > -1;
    },
    // 下拉框选中
    getActiveTab(item) {
      return (
        this.$route.name.indexOf(item.active) > -1 &&
        this.$route.query.id === item.type
      );
    },
    goProuductAll() {
      this.mouseName = 'plan';
      this.$router.push({
        name: 'aaa'
      });
    },
    goOther(url) {
      window.open(url);
    },
    phoneGo(item) {
      if (typeof item.select === 'boolean') {
        this.list.forEach(res => {
          console.log(item === res, item, res);
          if (item === res) {
            res.select = !res.select;
          } else if (res.select === true) {
            res.select = false;
          }
        });
      } else {
        this.go(item.router);
      }
    },
    // 操作菜单的显示
    showMenuChange(state) {
      this.showMenu = state;
      this.$store.commit('setTabShow', state);
      console.log(this.$store);
    }
  },
  watch: {
    $route(to, from) {
      if (to.meta.active) {
        this.tabIndex = to.meta.active; // 选中的标签的router
      } else {
        this.tabIndex = to.name;
      }
      window.scrollTo(0, 0);
      // Vue.nextTick(() => {
      //     if (document.querySelector('.app-content') && document.querySelector('.app-content').scrollTo) {
      //         document.querySelector('.app-content').scrollTo(0, 0)
      //     } else {
      //         document.querySelector('.app-content').scrollTop = 0
      //     }
      // })
      var hm = document.createElement('script');
      hm.src = 'https://hm.baidu.com/hm.js?749122ba802b492316b4e76cc78f5706';
      var s = document.getElementsByTagName('script')[0];
      s.parentNode.insertBefore(hm, s);

      const noIM = [
        'news',
        'newsDetail',
        'abstract',
        'history',
        'joinUs',
        'terrace',
        'jiangRegisterList',
        'pay'
      ];
      let baiDuIM = document.getElementById('newBridge');
      console.log(
        noIM.indexOf(to.name),
        to,
        document.getElementById('newBridge2')
      );
      if (noIM.indexOf(to.name) > -1) {
        baiDuIM.style.display = 'none';
      } else {
        baiDuIM.style.display = 'block';
      }
    }
  }
};
</script>
<style lang="less" scoped>
header {
  width: 100%;
  height: 80px;
  position: relative;
  z-index: 120;
  > div.hideHeader {
    height: 0;
    background: rgba(255, 255, 255, 0);
    box-shadow: none;
    > div .logo img {
      display: none;
    }
    > div .right .list {
      color: #fff;
      .tab {
        color: #fff;
        .line{
          display: none;
        }
      }
    }
    > div .right {
      .other {
        span {
          color: #fff;
        }
        img{
          display: none;
        }
        .other-box {
          svg{
            color: #fff;
          }
        }
        .whiteImg{
          display: block;
          filter: brightness(0) invert(1);
        }
      }
      .overseas {
          .other-box {
            img{
              display: block;
              filter: drop-shadow(#fff 0 60px);
            }
          }
        }
      .telephone {
        background: none;
        border: 1px solid #fff;
        img{
          display: none;
        }
        .whiteImg{
          display: block;
        }
        span {
          color: #fff;
        }
      }
    }
  }
  > div:hover {
    height: 80px;
    background: rgba(255, 255, 255, 1);
    box-shadow: 0px 2px 31px -8px rgba(0, 0, 0, 0.45);
    > div .logo img {
      display: block;
    }
    > div .right .list {
      color: #000000;
      .tab {
        color: #000000;
      }
    }
    > div .right {
      .other {
        span {
          color: #6b738c;
        }
        .other-box {
          svg{
            color: #6b738c;
          }
        }
        img{
          display: block;
        }
        .whiteImg{
          display: none;
        }
      }
      .overseas {
          .other-box {
            img{
              filter: drop-shadow(#6b738c 0 60px);
            }
          }
        }
      .telephone {
        background: #f1f1f1;
        border: none;
        img{
          display: block;
        }
        .whiteImg{
          display: none;
        }
        span {
          color: #f27529;
        }
      }
    }
  }
  .main {
    position: fixed;
    top: 0;
    left: 0;
    width: 100%;
    background: rgba(255, 255, 255, 100%);
    box-shadow: 0px 2px 31px -8px rgba(0, 0, 0, 0.45);
    opacity: 1;
    height: 80px;
    transition: all .5s;
    > div {
      width: 1300px;
      height: 80px;
      margin: 0 auto;
      display: flex;
      align-items: center;
      justify-content: space-between;
      position: relative;
      .logo {
        height: 57px;
        img {
          height: 100%;
        }
      }
      .right {
        display: flex;
        align-items: center;
        height: 100%;
        .list {
          padding: 0 20px;
          height: 100%;
          display: flex;
          align-items: center;
          justify-content: center;
          cursor: pointer;
          margin: 0 2px;
          .tab {
            font-size: 18px;
            font-weight: 400;
            color: #000000;
            line-height: 30px;
            display: flex;
            flex-direction: column;
            align-items: center;
            position: relative;
            .line {
              position: absolute;
              bottom: -13px;
              left: 50%;
              margin-left: -15px;
            }
            .line.active {
              width: 30px;
              height: 5px;
              border-radius: 7px;
              background-color: #f27529;
            }
          }

          .tab:hover {
            color: #f27529;
          }
          img {
            width: 10px;
            height: 12px;
            margin-left: 3px;
          }
        }
        .active {
          font-weight: bold;
          .tab {
            color: #f27529;
          }
        }
        .other {
          padding: 0;
          margin-right: 10px;
          .other-box {
            width: 110px;
            height: 35px;
            line-height: 35px;
            border-radius: 24px;
            display: flex;
            align-items: center;
            justify-content: center;
            // background: #fffcf3;
            svg{
              width: 19px;
              height: 19px;
              margin: 0 4px;
              color: #6b738c;
            }
          }
          img {
            color: #f27528;
            width: 16px;
            height: 16px;
            margin-right: 6px;
          }
          .whiteImg{
            display: none;
            filter: brightness(0) invert(1);
          }
          span {
            font-size: 14px;
            font-family: PingFangSC-Regular, PingFang SC;
            font-weight: 400;
            color: #6b738c;
          }
        }
        .overseas {
          margin-right: -15px;
          margin-left: 14px;
          .other-box {
            img{
              width: 20px;
              height: 20px;
              margin: 0 4px;
              transform: translateY(-60px);
              filter: drop-shadow(#6b738c 0 60px);
            }
          }
        }
        .telephone {
          width: 140px;
          height: 33px;
          border-radius: 24px;
          text-align: center;
          background-color: #f1f1f1;
          display: flex;
          justify-content: flex-start;
          align-items: center;
          padding-left: 2px;
          cursor: pointer;
          img {
            width: 33px;
            height: 33px;
            overflow: hidden;
            border-radius: 24px;
          }
          .whiteImg{
            display: none;
          }
          span {
            color: #f1703f;
            font-size: 14px;
          }
        }
      }
      .product {
        position: absolute;
        top: 80px;
        left: 0;
        width: 100%;
        height: 0px;
        // background: rgba(247, 243, 243, 0.92);
        background-color: #fff;
        // box-shadow:4px 4px 10px  rgba(0, 0, 0, 0.5);
        border-radius: 0 0 10px 10px;
        overflow: hidden;
        transition: 0.5s all;
        z-index: 103;
        align-items: center;
        box-shadow: 0px 3px 14px 0px rgba(0, 0, 0, 0.12);
        &.student-product,
        &.career-product,
        &.plat-product {
          display: flex;
          flex-direction: column;
          width: auto;
          align-items: center;
          justify-content: center;
          div {
            padding: 0 20px;
          }
        }
        &.student-product {
          left: 180px !important;
        }
        &.career-product {
          left: 300px !important;
        }
        &.plat-product {
          left: 530px !important;
        }
        div {
          // font-size: 20px!important;
          // line-height: 25px!important;
        }
        .contain {
          width: 100%;
          height: 100%;
          padding: 29px 80px;
          position: relative;
          .productList {
            width: 20%;
            float: left;
            margin: 11px 0;
            position: relative;
            display: flex;
            align-items: center;
            justify-content: center;
            flex-direction: column;
            cursor: pointer;
            > div {
              font-size: 16px !important;
              color: #444444;
              line-height: 22px;
              cursor: pointer;
              position: relative;
            }
            > .active {
              color: #f27529;
              font-weight: bold;
            }
            & > div:nth-child(1) {
              // font-weight: bold;
              // min-height: 30px;
            }
          }
          > .nopx-line {
            position: relative;
            top: -100%;
            left: 0;
            width: 100%;
            height: 100%;
            z-index: -1;
            display: flex;
            flex-direction: row;
            justify-content: flex-start;
            align-items: center;
            span {
              width: 20%;
              display: inline-block;
              height: 23px;
              border-right: 1px solid #e5e5e5;
              z-index: -1;
            }
          }
        }
      }
      .three .productList {
        width: 33%;
        &:last-child > .nopx-line {
          display: none;
        }
        > .nopx-line {
          height: 180px;
        }
        div:nth-child(2) {
          // font-weight: bold;
        }
      }
      .news {
        position: absolute;
        top: 80px;
        right: 542px;
        width: 101px;
        height: 0px;
        background: #fff;
        border-radius: 0 0 10px 10px;
        overflow: hidden;
        transition: 0.5s all;
        display: flex;
        flex-direction: column;
        align-items: center;
        justify-content: center;
        z-index: 103;
        div {
          font-size: 16px;
          color: #444444;
          line-height: 40px;
          // font-weight: bold;
          cursor: pointer;
        }
        > .active {
          color: #f27529;
          font-weight: bold;
        }
      }
      .about {
        position: absolute;
        top: 80px;
        right: 380px;
        width: 126px;
        height: 0px;
        background: #fff;
        border-radius: 0 0 10px 10px;
        overflow: hidden;
        transition: 0.5s all;
        display: flex;
        flex-direction: column;
        align-items: center;
        justify-content: center;
        z-index: 103;
        div {
          font-size: 16px;
          color: #444444;
          line-height: 40px;
          // font-weight: bold;
          cursor: pointer;
        }
        > .active {
          color: #f27529;
          font-weight: bold;
        }
      }
      .productService {
        left: 362px;
        width: 101px;
        background: #ffffff;
        box-shadow: 0px 3px 14px 0px rgba(0, 0, 0, 0.12);
        border-radius: 0px 0px 8px 8px;
        display: flex;
        align-items: center;
        justify-content: center;
        flex-direction: column;
        > div {
          font-size: 16px;
          font-weight: 400;
          color: #444444;
          line-height: 22px;
          margin-top: 22px;
          cursor: pointer;
        }
        > div:nth-child(1) {
          margin-top: 0;
        }
      }
      .product,
      .about, .news {
        div:hover {
          color: #f1703f !important;
        }
      }
      .showproductPlan {
        height: 278px;
        color: #f1703f;
      }
      .showproductNews {
        height: 116px;
        color: #f1703f;
      }
      .showproductAbout {
        height: 180px;
        color: #f1703f;
      }
      .showproductService {
        height: 120px;
        color: #f1703f;
      }
      .plan {
        transition: 0.5s all;
        position: absolute;
        overflow: hidden;
        left: 50%;
        margin-left: -466px;
        top: 80px;
        width: 892px;
        height: 295px;
        background: #ffffff;
        box-shadow: 0px 3px 14px 0px rgba(0, 0, 0, 0.12);
        border-radius: 0px 0px 8px 8px;
        height: 0px;
        max-height: 0;
        > div {
          display: flex;
          padding: 40px 80px 57px 80px;
          box-sizing: border-box;
          > div {
            .headline {
              font-size: 16px;
              font-weight: 500;
              color: #475974;
              line-height: 22px;
            }
            .content {
              width: 100%;
              display: flex;
              flex-wrap: wrap;
              .list {
                width: 120px;
                font-size: 16px;
                font-weight: 400;
                color: #000000;
                line-height: 22px;
                margin-top: 22px;
                cursor: pointer;
              }
              .list:hover {
                color: #f1703f;
              }
            }
          }
          .higher {
            width: 100%;
          }
          .k12 {
            width: 20%;
            .content .list{
              width: 150px;
            }
          }
          img {
            height: 62px;
            position: absolute;
            left: 582px;
            top: 50%;
            margin-top: -31px;
          }
        }
      }
      .showPlan {
        max-height: 400px;
        height: auto;
      }
    }
  }
  .mainPhone {
    z-index: 120;
    .top {
      width: 100%;
      height: 96px;
      position: fixed;
      top: 0;
      left: 0;
      background: #fff;
      display: flex;
      align-items: center;
      justify-content: center;
      z-index: 101;
      .more {
        position: absolute;
        top: 26px;
        left: 38px;
        width: 48px;
      }
      .icon {
        width: 136px;
      }
    }
    .showMore {
      position: fixed;
      top: 0;
      left: 0;
      width: 0;
      height: 100vh;
      z-index: 101;
      transition: all 0.3s;
      overflow: hidden;
      .content {
        width: 620px;
        height: 100%;
        background: #fff;
        padding: 0 48px 48px 48px;
        box-sizing: border-box;
        overflow: auto;
        .close {
          width: 48px;
          height: 48px;
          margin-top: 20px;
        }
        .list {
          width: 100%;
          border-bottom: 2px solid rgba(36, 46, 62, 0.1);
          .title {
            width: 100%;
            display: flex;
            justify-content: space-between;
            align-items: center;
            height: 100px;
            span {
              font-size: 32px;
              color: rgba(0, 0, 0, 0.87);
              line-height: 48px;
              font-weight: 400;
            }
            .active {
              color: #f27529;
            }
            img {
              width: 32px;
              height: 32px;
              transition: all 0.3s;
              transform: rotate(0deg);
            }
            .imgSetect {
              transform: rotate(90deg);
            }
          }
          .classify {
            width: 100%;
            height: 60px;
            display: flex;
            align-items: center;
            .circle {
              width: 8px;
              height: 8px;
              background: #d0d1d8;
              margin: 0 28px 0 12px;
            }
            span {
              font-size: 28px;
              color: rgba(36, 46, 62, 0.48);
              line-height: 1;
              font-weight: 500;
            }
            .active {
              color: #f27529;
            }
          }
          .tag {
            height: 84px;
            display: flex;
            align-items: center;
            .circle {
              width: 8px;
              height: 8px;
              background: #d0d1d8;
              margin: 0 28px 0 12px;
              opacity: 0;
            }
            span {
              font-size: 32px;
              color: rgba(0, 0, 0, 0.87);
              line-height: 48px;
              font-weight: 400;
            }
            .active {
              color: #f27529;
            }
            img {
              height: 24px;
              margin-left: 20px;
            }
          }
          .heightHide {
            height: 0;
            overflow: hidden;
            transition: all 0.3s;
          }
          .showProduct {
            height: 1200px;
          }
          .showCareer {
            height: 550px;
          }
          .showStudent {
            height: 450px;
          }
          .showDatePlatform {
            height: 100px;
            // height: 190px;
          }
          .showPlan {
            height: auto;
          }
          .showNews {
            height: 200px;
          }
          .showProduct {
            height: 220px;
          }
          .showAbout {
            height: 340px;
          }
        }
        .list:last-child {
          border: none;
        }
      }
    }
    .showMoreCover {
      position: fixed;
      top: 0;
      left: 0;
      width: 100vw;
      height: 100vh;
      background: rgba(0, 0, 0, 0.3);
      z-index: 100;
      transition: all 0.6s;
      overflow: hidden;
      opacity: 0;
    }
    .showMenu {
      width: 620px;
    }
    .showMenuCover {
      opacity: 1;
    }
  }
}
@media (max-width: 1000px) {
  header{
    height: 0 !important;
    > div:hover {
      height: auto !important;
    }
  }
}
</style>
